export const width=1507;export const height=1050;export default{width:width,height:height};